import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { Container, Section, SectionHeading, Card, Reveal } from "../Components/UI";
import { posts } from "./posts";

const BlogPage: React.FC = () => {
  return (
    <main className="bg-ink-950 pt-16 md:pt-20">
      <Navbar />

      <Section className="!pb-10">
        <Container>
          <Reveal>
            <SectionHeading
              eyebrow="Blog"
              title="Ideas on energy, India & impact"
              intro="Simple, honest writing on clean energy, self-reliance and the journey of building deep-tech from India."
            />
          </Reveal>
        </Container>
      </Section>

      <Section className="!pt-0">
        <Container>
          <div className="grid gap-8 md:grid-cols-2">
            {posts.map((post, i) => (
              <Reveal key={post.slug} delay={i * 100}>
                <Link to={`/blog/${post.slug}`} className="group block h-full">
                  <Card className="h-full overflow-hidden transition-colors hover:border-brand-500/40">
                    <div className="relative aspect-[16/9] overflow-hidden">
                      <img
                        src={post.cover}
                        alt={post.title}
                        loading="lazy"
                        decoding="async"
                        className="h-full w-full object-cover object-[50%_42%] transition-transform duration-700 group-hover:scale-105"
                      />
                      <span className="absolute left-4 top-4 rounded-full bg-brand-500 px-3 py-1 text-[11px] font-semibold text-ink-950">
                        {post.category}
                      </span>
                    </div>
                    <div className="p-6">
                      <div className="flex items-center gap-3 text-xs text-zinc-500">
                        <span>{post.date}</span>
                        <span className="inline-flex items-center gap-1">
                          <Clock className="h-3.5 w-3.5" /> {post.readMins} min read
                        </span>
                      </div>
                      <h3 className="mt-3 font-display text-xl font-bold leading-snug text-white">
                        {post.title}
                      </h3>
                      <p className="mt-3 text-sm leading-relaxed text-zinc-400">
                        {post.excerpt}
                      </p>
                      <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-400">
                        Read article{" "}
                        <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                      </span>
                    </div>
                  </Card>
                </Link>
              </Reveal>
            ))}
          </div>
        </Container>
      </Section>

      <Footer />
    </main>
  );
};

export default BlogPage;
